<div *ngIf="ticket">
  <app-ticket-editor [ticket]="ticket" title="{{ ticket.Title }} #{{ ticket.Id }}"></app-ticket-editor>
</div>
